// Runtime URL rewriter for fetch() calls.
//
// The codebase has ~80 hardcoded `https://apsrecruiting.io/api/...` URLs in
// page/component fetch calls. Rather than touch every site, we install a
// fetch wrapper at app boot that rewrites the prod URL to whatever
// REACT_APP_API_URL points to in the current build (staging or local dev).
//
// In a prod build with REACT_APP_API_URL unset (or set to the prod URL),
// this is a no-op — the wrapper isn't installed.

const PROD_API_URL = 'https://apsrecruiting.io/api';
const ACTUAL_API_URL = process.env.REACT_APP_API_URL || PROD_API_URL;

if (ACTUAL_API_URL !== PROD_API_URL) {
  const origFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    let rewritten: RequestInfo | URL = input;
    if (typeof input === 'string' && input.startsWith(PROD_API_URL)) {
      rewritten = ACTUAL_API_URL + input.slice(PROD_API_URL.length);
    } else if (input instanceof URL && input.href.startsWith(PROD_API_URL)) {
      rewritten = new URL(ACTUAL_API_URL + input.href.slice(PROD_API_URL.length));
    } else if (input instanceof Request && input.url.startsWith(PROD_API_URL)) {
      rewritten = new Request(ACTUAL_API_URL + input.url.slice(PROD_API_URL.length), input);
    }
    return origFetch(rewritten, init);
  };
  // eslint-disable-next-line no-console
  console.info(`[api] redirecting ${PROD_API_URL} → ${ACTUAL_API_URL}`);
}

export {};
